import React, { forwardRef } from "react";
// @mui
import { useTheme } from "@mui/material/styles";
import { Box, Link, BoxProps } from "@mui/material";

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
  sizeLogo?: number;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, sx, sizeLogo = 200, ...other }, ref) => {
    const theme = useTheme();
    const PRIMARY_LIGHT = theme.palette.primary.light;

    const PRIMARY_MAIN = theme.palette.primary.main;

    const PRIMARY_DARK = theme.palette.primary.dark;

    const logo = (
      <Box
        ref={ref}
        component="div"
        sx={{
          width: sizeLogo,
          height: "auto",
          alignItems: "center",
          margin: "auto",
          ...sx,
        }}
        {...other}
      >
        <svg
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 923.96 279.84"
        >
          <title>Untitled-2</title>
          <path
            fill={PRIMARY_DARK}
            d="M0,157.91l217.41.22a9.66,9.66,0,0,0-.16,1.81v17.48a10.07,10.07,0,0,0,.13,1.63L0,178.82Z"
          />
          <path
            fill={PRIMARY_LIGHT}
            d="M235.52,157.91l217.41.22a9.66,9.66,0,0,0-.16,1.81v17.48a11.42,11.42,0,0,0,.12,1.63l-217.37-.23Z"
          />
          <path
            fill={PRIMARY_DARK}
            d="M471,157.91l217.4.22a10.66,10.66,0,0,0-.15,1.81v17.48a10.13,10.13,0,0,0,.12,1.63L471,178.82Z"
          />
          <path
            fill={PRIMARY_LIGHT}
            d="M706.56,157.91l217.4.22a10.66,10.66,0,0,0-.15,1.81v17.48a10.13,10.13,0,0,0,.12,1.63l-217.37-.23Z"
          />
          {/* Chữ taM */}
          <path
            fill={PRIMARY_MAIN}
            d="M924,134.08q0,2.78-3.4,2.77H900.28a2.91,2.91,0,0,1-2.24-1.13,3.6,3.6,0,0,1-1-2.52V48.5c0-1.25-.2-1.88-.6-1.88-.2,0-.5.39-1,1.15l-19.28,34.8c-1.23,2.07-3.37,3.1-6.38,3.1H849.6c-3,0-5.15-1-6.39-3.1l-19.47-34.8c-.44-.76-.77-1.15-1-1.15-.4,0-.57.63-.57,1.88v84.7a3.63,3.63,0,0,1-1,2.52,2.88,2.88,0,0,1-2.24,1.13H798.68q-3.4,0-3.41-2.77V8.72a6.74,6.74,0,0,1,2.34-5.17,8.19,8.19,0,0,1,5.68-2.12h16.44a8.14,8.14,0,0,1,7.45,4.37l30.23,55.76c1,1.73,1.71,2.58,2.17,2.58s1.27-.85,2.24-2.58L892.06,5.8a8.12,8.12,0,0,1,7.45-4.37H916a8.14,8.14,0,0,1,5.68,2.12A6.73,6.73,0,0,1,924,8.72Z"
          />
          {/*Chữ Tam */}
          <path
            fill={PRIMARY_MAIN}
            d="M667.65,19.31a2.79,2.79,0,0,1-1.17,2.43,4.68,4.68,0,0,1-2.84.85h-35V133.2a3.32,3.32,0,0,1-1.17,2.61,4.13,4.13,0,0,1-2.84,1H604.71a4.23,4.23,0,0,1-2.74-1.07,3.23,3.23,0,0,1-1.27-2.58V22.59H565.65a4.45,4.45,0,0,1-2.84-.88,2.89,2.89,0,0,1-1.17-2.4V4.89a3.11,3.11,0,0,1,1.14-2.43,4,4,0,0,1,2.87-1h98a4.21,4.21,0,0,1,2.87.94,3.13,3.13,0,0,1,1.14,2.52Z"
          />
          {/* Chữ toaN */}
          <path
            fill={PRIMARY_LIGHT}
            d="M494.29,129.56a6.84,6.84,0,0,1-2.34,5.16,8.14,8.14,0,0,1-5.68,2.13H466a19.25,19.25,0,0,1-7.32-1.16c-1.83-.79-3.47-2.58-4.91-5.44L409.33,41.54c-.54-.94-1.14-1.42-1.87-1.42s-1,.48-1,1.42V133.2a3.3,3.3,0,0,1-1.14,2.61,3.72,3.72,0,0,1-2.67,1h-17a4.25,4.25,0,0,1-2.74-1.07,3.35,3.35,0,0,1-1.27-2.58V8.72A6.74,6.74,0,0,1,384,3.55a8.19,8.19,0,0,1,5.68-2.12H411.3a9.54,9.54,0,0,1,5.21,1.24,11.36,11.36,0,0,1,3.58,4.62L466.79,101c.51,1,1.07,1.43,1.64,1.43s1-.55,1-1.7V4.89A3.21,3.21,0,0,1,470.5,2.4a4,4,0,0,1,2.74-1h17.24a4,4,0,0,1,2.74,1,3.31,3.31,0,0,1,1.07,2.49Z"
          />
          {/* Chữ toAn */}
          <path
            fill={PRIMARY_MAIN}
            d="M307.63,24.2a5.41,5.41,0,0,0-1.13-2.27,3.24,3.24,0,0,0-2.11-.58,2.91,2.91,0,0,0-2,.58,5,5,0,0,0-1.14,2.27L272.18,133.72a3.8,3.8,0,0,1-1.43,2.18,3.57,3.57,0,0,1-2.37.95H247.13a4,4,0,0,1-2.61-.85,2.78,2.78,0,0,1-1-2.28.93.93,0,0,0,.13-.34,2,2,0,0,0,0-.54l32.9-114.25Q281.86,0,304.39,0t27.9,18.59l32.87,114.25a4.7,4.7,0,0,1,.17.45,1.94,1.94,0,0,1,0,.43,2.72,2.72,0,0,1-1,2.28,3.85,3.85,0,0,1-2.57.85H340.51a3.65,3.65,0,0,1-2.41-.95,4,4,0,0,1-1.4-2.18Z"
          />
          {/* Chữ tAm */}
          <path
            fill={PRIMARY_LIGHT}
            d="M721.27,24.2a5.41,5.41,0,0,0-1.13-2.27,3.24,3.24,0,0,0-2.11-.58,2.89,2.89,0,0,0-2,.58,5,5,0,0,0-1.14,2.27L685.82,133.72a3.85,3.85,0,0,1-1.43,2.18,3.58,3.58,0,0,1-2.38.95H660.77a4,4,0,0,1-2.61-.85,2.78,2.78,0,0,1-1-2.28.93.93,0,0,0,.13-.34,2,2,0,0,0,0-.54l32.9-114.25Q695.5,0,718,0t27.9,18.59L778.8,132.84c.07.18.13.33.17.45a1.94,1.94,0,0,1,0,.43,2.72,2.72,0,0,1-1,2.28,3.86,3.86,0,0,1-2.58.85H754.15a3.65,3.65,0,0,1-2.41-.95,4,4,0,0,1-1.4-2.18Z"
          />
          <path
            fill={PRIMARY_MAIN}
            d="M106,19.31a2.79,2.79,0,0,1-1.17,2.43,4.68,4.68,0,0,1-2.84.85H67V133.2a3.32,3.32,0,0,1-1.17,2.61,4.15,4.15,0,0,1-2.84,1H43.06a4.27,4.27,0,0,1-2.74-1.07,3.25,3.25,0,0,1-1.26-2.58V22.59H4a4.45,4.45,0,0,1-2.84-.88A2.89,2.89,0,0,1,0,19.31V4.89A3.11,3.11,0,0,1,1.14,2.46,4,4,0,0,1,4,1.43h98a4.21,4.21,0,0,1,2.87.94A3.13,3.13,0,0,1,106,4.89Z"
          />
          {/* Chữ tOan */}
          <path
            fill={PRIMARY_LIGHT}
            d="M206.1,62.93V56.85c0-12-2.37-20.77-7.08-26.36q-5.53-6.55-15.77-8V.21A67.69,67.69,0,0,1,206.8,6,43.85,43.85,0,0,1,227,24.69q7.26,12.75,7.25,32.16v6.08Z"
          />
          <path
            fill={PRIMARY_LIGHT}
            d="M206.1,81.42V75.35h28.1v6.07q0,19.41-7.25,32.16a43.85,43.85,0,0,1-20.15,18.74,67.47,67.47,0,0,1-23.55,5.74V115.87q10.23-1.47,15.77-8.09,7.06-8.48,7.08-26.36"
          />
          <path
            fill={PRIMARY_LIGHT}
            d="M148,75.35v6.07q0,17.86,7.08,26.36,5.55,6.63,15.77,8.09v22.19a67.24,67.24,0,0,1-23.52-5.74,44.11,44.11,0,0,1-20.18-18.74c-4.81-8.5-7.25-19.22-7.25-32.16V75.35Z"
          />
          <path
            fill={PRIMARY_LIGHT}
            d="M170.82,22.49q-10.23,1.46-15.77,8c-4.71,5.59-7.08,14.4-7.08,26.36v6.08h-28.1V56.85c0-12.94,2.44-23.66,7.25-32.16A44.11,44.11,0,0,1,147.3,6,67.24,67.24,0,0,1,170.82.21Z"
          />
          {/* End Chữ tOan */}
          {/* chữ PRINT */}
          <path
            fill={PRIMARY_MAIN}
            d="M239.29,271h6.23V211.91h20.94v-5.79H218.34v5.79h20.95Zm-84.87,0h5.88V215.85h.17L197.37,271h5.52V206.12H197v53.47h-.17l-35.76-53.47h-6.67Zm-27.89,0h6.22V206.12h-6.22Zm-57.7-34.62V211.82H83.9c10.87,0,16.83,3.16,16.83,12.1,0,9.37-6,12.44-16.74,12.44ZM62.69,271h6.14v-29.1H85L100.82,271h7l-16.39-29.8c9.38-1.75,15.52-7,15.52-17.53,0-11.39-8.07-17.53-22.53-17.53H62.69ZM8.41,236.71V211.82H23.49c10.87,0,16.74,3.42,16.74,12.18,0,9.38-6,12.71-16.65,12.71ZM2.19,271H8.41V242.23H23.14c13.67,0,23.31-5.34,23.31-18.4,0-11.92-8.59-17.71-22.7-17.71H2.19Z"
          />
          {/* chữ PRO */}
          <path
            fill={PRIMARY_MAIN}
            d="M483.54,266.6c-12.27,0-21.12-10.43-21.12-28.05s8.85-28,21.12-28,21.13,10.35,21.13,28-8.86,28.05-21.13,28.05m0,5.61c15.87,0,27.35-13.32,27.35-33.66s-11.48-33.65-27.35-33.65-27.34,13.32-27.34,33.65S467.68,272.21,483.54,272.21Zm-80.13-35.85V211.82h15.07c10.87,0,16.83,3.16,16.83,12.1,0,9.37-6.05,12.44-16.74,12.44ZM397.27,271h6.14v-29.1h16.12L435.4,271h7L426,241.18c9.38-1.75,15.51-7,15.51-17.53,0-11.39-8.06-17.53-22.52-17.53H397.27ZM343,236.71V211.82h15.08c10.87,0,16.74,3.42,16.74,12.18,0,9.38-6,12.71-16.65,12.71ZM336.77,271H343V242.23h14.73c13.67,0,23.31-5.34,23.31-18.4,0-11.92-8.59-17.71-22.7-17.71H336.77Z"
          />
          {/* chữ CO.,LTD */}
          <path
            fill={PRIMARY_MAIN}
            d="M881.54,265.37V211.91h11c16.13,0,25.24,8.24,25.24,26.56,0,18.75-9,26.9-25.07,26.9ZM875.32,271h16.39c20.86,0,32.25-11.13,32.25-32.51s-11.13-32.35-32.25-32.35H875.32Zm-42.62,0h6.22V211.91h21v-5.79H811.75v5.79h21ZM769,271H806.9v-5.69H775.18V206.12H769Zm-27.19,8.86h2.8l4-9.65v-7.45H741V271h2.89ZM713.33,271h7.54v-8.24h-7.54Zm-40.25-4.38c-12.27,0-21.13-10.43-21.13-28.05s8.86-28,21.13-28,21.12,10.35,21.12,28S685.35,266.6,673.08,266.6Zm0,5.61c15.86,0,27.34-13.32,27.34-33.66s-11.48-33.65-27.34-33.65-27.35,13.32-27.35,33.65S657.21,272.21,673.08,272.21Zm-64.89,0c13,0,21.39-8,24.54-20.77l-6-1.32C624,261,617.92,266.6,608.28,266.6c-12.62,0-20.86-10.52-20.86-28.48,0-16.66,8.15-27.53,20.68-27.53,9.91,0,14.73,5.35,17.62,15.6l6-1.49c-3.07-12-10.34-19.8-23.49-19.8-16.21,0-27,13.76-27,33.39C581.2,259,591.8,272.21,608.19,272.21Z"
          />
        </svg>
      </Box>
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link component="a" href="/">
        {logo}
      </Link>
    );
  }
);

export default Logo;
